import { render, staticRenderFns } from "./PartnerWalletTransactions.vue?vue&type=template&id=375f4ff4&"
import script from "./PartnerWalletTransactions.vue?vue&type=script&lang=js&"
export * from "./PartnerWalletTransactions.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWalletTransactions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports